// Обрезаем всё в url после `?`
// /issues?foo=bar => /issues
export default function trimQueryParams(url: string) {
  return url.replace(/\?[\w\d\D]+/g, '');
}
